import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { ITestKitOrder, TestKitOrder } from '../TestKitOrder.ts';
import { TestKitOrderApi } from '../../../apis/TestKitOrderApi/TestKitOrderApi.ts';

export function useGetTestKitOrderNew() {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.testkitorderNew],
        queryFn: async () => {
            const result: ITestKitOrder = await TestKitOrderApi.getTestKitOrdersNew();
            return new TestKitOrder(result);
        },
    });
}
